import { ReactNode } from "react";
import { Page } from "containers/Page";
import { Container } from "./style";

interface Props {
  title: string;
  children: ReactNode;
  loading?: boolean;
  lastPage?: string;
  redirectDoIcone?: string;
}

export function PageV2({
  title,
  children,
  loading,
  lastPage,
  redirectDoIcone,
}: Props) {
  return (
    <Page
      title={title}
      loading={loading}
      lastPage={lastPage}
      redirectDoIcone={redirectDoIcone}
    >
      <Container>{children}</Container>
    </Page>
  );
}
